[
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Data Channels",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/2555905",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.data-channels"],
    "paths": [
      "/open-insurance/channels/v2/branches",
      "/open-insurance/channels/v2/electronic-channels",
      "/open-insurance/channels/v2/phone-channels"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN provider open-data routes in the insurance holder-data boundary."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Intermediary",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.intermediary"],
    "paths": ["/open-insurance/channels/v2/intermediary/{countrySubDivision}"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Referenced Network",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.referenced-network"],
    "paths": ["/open-insurance/channels/v2/referenced-network/{countrySubDivision}/{serviceType}"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Assistance General Assets",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.assistance-general-assets"],
    "paths": ["/open-insurance/products-services/v2/assistance-general-assets"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Auto Extended Warranty",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.auto-extended-warranty"],
    "paths": ["/open-insurance/products-services/v2/auto-extended-warranty"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Auto Insurance",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.auto-insurance"],
    "paths": [
      "/open-insurance/products-services/v2/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Business",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.business"],
    "paths": ["/open-insurance/products-services/v2/business"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Capitalization Title",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.capitalization-title"],
    "paths": ["/open-insurance/products-services/v2/capitalization-title"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Condominium",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.condominium"],
    "paths": ["/open-insurance/products-services/v2/condominium/{commercializationArea}"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Cyber Risk",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.cyber-risk"],
    "paths": ["/open-insurance/products-services/v2/cyber-risk"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Directors & Officers Liability",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.directors-officers-liability"],
    "paths": ["/open-insurance/products-services/v2/directors-officers-liability"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Domestic Credit",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.domestic-credit"],
    "paths": ["/open-insurance/products-services/v2/domestic-credit"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Engineering",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.engineering"],
    "paths": ["/open-insurance/products-services/v2/engineering"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Environmental Liability",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.environmental-liability"],
    "paths": ["/open-insurance/products-services/v2/environmental-liability"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Equipment Breakdown",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.equipment-breakdown"],
    "paths": ["/open-insurance/products-services/v2/equipment-breakdown"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Errors & Omissions Liability",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.errors-omissions-liability"],
    "paths": ["/open-insurance/products-services/v2/errors-omissions-liability"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Export Credit",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.export-credit"],
    "paths": ["/open-insurance/products-services/v2/export-credit"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Extended Warranty",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.extended-warranty"],
    "paths": ["/open-insurance/products-services/v2/extended-warranty"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Financial Risk",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.financial-risk"],
    "paths": ["/open-insurance/products-services/v2/financial-risk"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — General Liability",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.general-liability"],
    "paths": ["/open-insurance/products-services/v2/general-liability"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Home Insurance",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.home-insurance"],
    "paths": [
      "/open-insurance/products-services/v2/home-insurance/commercializationArea/{commercializationArea}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Housing",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.housing"],
    "paths": ["/open-insurance/products-services/v2/housing"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Life Pension",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.life-pension"],
    "paths": ["/open-insurance/products-services/v2/life-pension"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Lost Profit",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.lost-profit"],
    "paths": ["/open-insurance/products-services/v2/lost-profit"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Pension Plan",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.pension-plan"],
    "paths": ["/open-insurance/products-services/v2/pension-plan"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Person",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.person"],
    "paths": ["/open-insurance/products-services/v2/person"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Private Guarantee",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.private-guarantee"],
    "paths": ["/open-insurance/products-services/v2/private-guarantee"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Public Guarantee",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.public-guarantee"],
    "paths": ["/open-insurance/products-services/v2/public-guarantee"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Rent Guarantee",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.rent-guarantee"],
    "paths": ["/open-insurance/products-services/v2/rent-guarantee"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Rural",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.rural"],
    "paths": ["/open-insurance/products-services/v2/rural"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Stop Loss",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.stop-loss"],
    "paths": ["/open-insurance/products-services/v2/stop-loss"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Transport",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753678",
    "ownerPackage": "@finnest/insurance-open-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.open-data.transport"],
    "paths": ["/open-insurance/products-services/v2/transport"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-open-data' test:contract"
      }
    ],
    "notes": "Phase 1 OPIN open-data — public, no consent, no auth."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Consents",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753728",
    "ownerPackage": "@finnest/insurance-consent-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.consents"],
    "paths": [
      "/open-insurance/consents/v3/consents",
      "/open-insurance/consents/v3/consents/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-consent-holder' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-consent-holder' test:contract"
      }
    ],
    "notes": "Canonical OPIN Consents v3 provider routes with full FSM lifecycle. Receiver workflow is a separate surface."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Consents",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "finnest-receiver-workflow",
    "targetProfile": "finnest-as-is",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753728",
    "ownerPackage": "@finnest/insurance-receiver-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.receiver.connections"],
    "paths": ["/open-insurance/v1/connections"],
    "scalarPath": "/reference/insurance#tag/insurance.receiver.connections",
    "evidence": [
      {
        "kind": "command",
        "value": "bun insurance:ci"
      }
    ],
    "notes": "Finnest receiver workflow — calls remote provider consent APIs to drive user-facing journey."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Resources",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.resources"],
    "paths": ["/open-insurance/resources/v3/resources"],
    "scalarPath": "/reference/insurance#tag/insurance.holder.resources",
    "evidence": [
      {
        "kind": "command",
        "value": "bun insurance:ci"
      }
    ],
    "notes": "Canonical OPIN Resources v3 provider route implemented. Aggregates resources from all Phase 2 product family tables. Receiver workflow record access lives in @finnest/insurance-receiver-data (separate surface)."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Customers",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4259841",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.customers"],
    "paths": [
      "/open-insurance/customers/v2/personal/identifications",
      "/open-insurance/customers/v2/personal/qualifications",
      "/open-insurance/customers/v2/personal/complimentary-information",
      "/open-insurance/customers/v2/business/identifications",
      "/open-insurance/customers/v2/business/qualifications",
      "/open-insurance/customers/v2/business/complimentary-information"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Customers v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Auto",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.auto"],
    "paths": [
      "/open-insurance/insurance-auto/v2/insurance-auto",
      "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/policy-info",
      "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/premium",
      "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Auto v2 provider routes; v1 remains mounted."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Patrimonial",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.patrimonial"],
    "paths": [
      "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial",
      "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/policy-info",
      "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/premium",
      "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Patrimonial v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Person",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.person"],
    "paths": [
      "/open-insurance/insurance-person/v2/insurance-person",
      "/open-insurance/insurance-person/v2/insurance-person/{policyId}/policy-info",
      "/open-insurance/insurance-person/v2/insurance-person/{policyId}/premium",
      "/open-insurance/insurance-person/v2/insurance-person/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Current OPIN Person v2 provider routes; deprecated v1 remains mounted."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Housing",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.housing"],
    "paths": [
      "/open-insurance/insurance-housing/v2/insurance-housing",
      "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/policy-info",
      "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/premium",
      "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Housing v2 provider routes; v1 remains mounted."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Financial Risk",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.financial-risk"],
    "paths": [
      "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk",
      "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/policy-info",
      "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/premium",
      "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Financial Risk v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Responsibility",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.responsibility"],
    "paths": [
      "/open-insurance/insurance-responsibility/v2/insurance-responsibility",
      "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/policy-info",
      "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/premium",
      "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Responsibility v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Rural",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.rural"],
    "paths": [
      "/open-insurance/insurance-rural/v2/insurance-rural",
      "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/policy-info",
      "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/premium",
      "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Rural v2 provider routes; v1 remains mounted."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Transport",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.transport"],
    "paths": [
      "/open-insurance/insurance-transport/v2/insurance-transport",
      "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/policy-info",
      "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/premium",
      "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Transport v2 provider routes; v1 remains mounted."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Acceptance And Branches Abroad",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.acceptance-and-branches-abroad"],
    "paths": [
      "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad",
      "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/policy-info",
      "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/premium",
      "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Acceptance & Branches Abroad v2.0.0 provider routes (stable)."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Financial Assistance",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4129464",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.financial-assistance"],
    "paths": [
      "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/contracts",
      "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/contract-info",
      "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/movements"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Current OPIN Financial Assistance v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Capitalization Title",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4194853",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.capitalization-title"],
    "paths": [
      "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/plans",
      "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/plan-info",
      "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/events",
      "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/settlements"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Current OPIN Capitalization Title v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Pension Plan",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4195028",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.pension-plan"],
    "paths": [
      "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/contracts",
      "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/contract-info",
      "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/movements",
      "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/portabilities",
      "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/withdrawals",
      "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Current OPIN Pension Plan v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "2",
    "family": "Life Pension",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4194960",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.products.life-pension"],
    "paths": [
      "/open-insurance/insurance-life-pension/v2/insurance-life-pension/contracts",
      "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/contract-info",
      "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/movements",
      "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/portabilities",
      "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/withdrawals",
      "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/claim"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Current OPIN Life Pension v2 provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Claim Notification",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.commands"],
    "paths": [
      "/open-insurance/claim-notification/v2/request/damage/{consentId}",
      "/open-insurance/claim-notification/v2/request/person/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical OPIN Claim Notification command foundation with idempotency, audit records, and event outbox publication."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Endorsement",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.commands"],
    "paths": ["/open-insurance/endorsement/v2/request/{consentId}"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "Canonical Endorsement v2.0.0 route. Replaced v1.0.0 RC. Typed request/response, consent path param, idempotency, protocol number."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Notifications",
    "regulatoryVersion": "v1.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.commands"],
    "paths": ["/open-insurance/notifications/v1/quote-notification"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:contract"
      }
    ],
    "notes": "OPIN Notifications v1.0.0 single-shot quote-notification (ACPT/RJCT) with idempotency key, audit, and outbox event."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Auto",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-auto.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/quote-auto/v2/lead/request",
      "/open-insurance/quote-auto/v2/lead/request/{consentId}",
      "/open-insurance/quote-auto/v2/request",
      "/open-insurance/quote-auto/v2/request/{consentId}/quote-status",
      "/open-insurance/quote-auto/v2/request/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Housing",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-housing.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/quote-housing/v2/lead/request",
      "/open-insurance/quote-housing/v2/lead/request/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Rural",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-rural.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/quote-rural/v2/lead/request",
      "/open-insurance/quote-rural/v2/lead/request/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Transport",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-transport.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/quote-transport/v2/lead/request",
      "/open-insurance/quote-transport/v2/lead/request/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Person",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-person.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/quote-person/v2/lead/request",
      "/open-insurance/quote-person/v2/lead/request/{consentId}",
      "/open-insurance/quote-person/v2/life/request",
      "/open-insurance/quote-person/v2/life/request/{consentId}/quote-status",
      "/open-insurance/quote-person/v2/life/request/{consentId}",
      "/open-insurance/quote-person/v2/travel/request",
      "/open-insurance/quote-person/v2/travel/request/{consentId}/quote-status",
      "/open-insurance/quote-person/v2/travel/request/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Capitalization Title",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-capitalization-title.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/quote-capitalization-title/v2/lead/request",
      "/open-insurance/quote-capitalization-title/v2/lead/request/{consentId}",
      "/open-insurance/quote-capitalization-title/v2/request",
      "/open-insurance/quote-capitalization-title/v2/request/{consentId}/quote-status",
      "/open-insurance/quote-capitalization-title/v2/request/{consentId}",
      "/open-insurance/quote-capitalization-title/v2/raffle/request"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Contract Life Pension",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-life-pension.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.quotes"],
    "paths": [
      "/open-insurance/contract-life-pension/v2/lead/request",
      "/open-insurance/contract-life-pension/v2/lead/request/{consentId}",
      "/open-insurance/contract-life-pension/v2/request",
      "/open-insurance/contract-life-pension/v2/request/{consentId}/quote-status",
      "/open-insurance/contract-life-pension/v2/request/{consentId}"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Withdrawal",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-life-pension-withdrawal.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.processing"],
    "paths": [
      "/open-insurance/withdrawal/v2/lead/request",
      "/open-insurance/withdrawal/v2/pension/request",
      "/open-insurance/withdrawal/v2/capitalization-title/request"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Dynamic Fields",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/dynamic-fields.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.dynamic-fields"],
    "paths": [
      "/open-insurance/dynamic-fields/v2/damage-and-person",
      "/open-insurance/dynamic-fields/v2/capitalization-title",
      "/open-insurance/dynamic-fields/v2/callback/damage-and-person",
      "/open-insurance/dynamic-fields/v2/callback/capitalization-title"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Webhook",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/webhook.yaml",
    "ownerPackage": "@finnest/insurance-service-initiation-holder",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.current.webhooks"],
    "paths": [
      "/open-insurance/webhook/v2/quote/{versionApi}/request/{consentId}/quote-status",
      "/open-insurance/webhook/v2/products-services/{authorisationServerId}/{versionApi}/capitalization-title",
      "/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/damage-and-person",
      "/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/capitalization-title"
    ],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun test:integration --scope=package:@finnest/insurance-service-initiation-holder"
      }
    ],
    "notes": "Current v2.0.0 operations from pinned official source 23bc730b2a0d5fcb65bff3513218a293f016e8a9. Local implementation evidence is separate from external acceptance."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Comuns (Status & Outages)",
    "regulatoryVersion": "v1.3.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/main/documentation/source/files/swagger/current/discovery.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.discovery"],
    "paths": ["/open-insurance/discovery/v1/status", "/open-insurance/discovery/v1/outages"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      }
    ],
    "notes": "Canonical OPIN discovery status and scheduled-outage provider routes."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Admin (Metrics)",
    "regulatoryVersion": "v1.3.0",
    "lifecycle": "deprecated",
    "surface": "opin-provider-canonical",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/main/documentation/source/files/swagger/current/admin_metrics.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": ["insurance.holder.admin"],
    "paths": ["/open-insurance/admin/v1/metrics"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      },
      {
        "kind": "command",
        "value": "bun run --filter '@finnest/insurance-holder-data' test:unit"
      }
    ],
    "notes": "Canonical OPIN administrative availability-metrics provider route."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Power Admin OPIN Governance",
    "regulatoryVersion": "internal",
    "lifecycle": "current",
    "surface": "power-admin-customer",
    "targetProfile": "power-admin-customer",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD",
    "ownerPackage": "@finnest/power-admin",
    "service": "power-admin",
    "status": "implemented",
    "openapiTags": [],
    "paths": ["/"],
    "evidence": [
      {
        "kind": "artifact",
        "value": "apps/power-admin/src/opin/core/governance.tsx"
      }
    ],
    "notes": "Admin/customer-facing governance surface that visualizes canonical OPIN targets, Finnest AS IS routes, and MockOPIN evidence."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Idempotency (Idempotência)",
    "regulatoryVersion": "v1",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/1851393",
    "ownerPackage": "@finnest/middleware",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": [],
    "paths": [],
    "evidence": [
      {
        "kind": "artifact",
        "value": "packages/middleware/src/idempotency"
      }
    ],
    "notes": "OPIN binding requirement — every POST/PATCH on holder routes must respect a client-supplied idempotency key. Implemented at the middleware layer; tracked here so governance reports it."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Versioning Policy (Multiversionamento)",
    "regulatoryVersion": "v1",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/1851393",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "implemented",
    "openapiTags": [],
    "paths": [],
    "evidence": [
      {
        "kind": "artifact",
        "value": "services/insurance/openapi.json"
      }
    ],
    "notes": "OPIN multiversioning rule — provider routes carry the regulator version in the path (v1, v2, v3). The catalog tracks regulatoryVersion per family so drift is visible."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Data Channels (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/data_channels.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/channels/v3/branches",
      "/open-insurance/channels/v3/electronic-channels",
      "/open-insurance/channels/v3/phone-channels"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Intermediary (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/intermediary.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/channels/v3/intermediary/{countrySubDivision}"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Referenced Network (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/referenced-network.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/channels/v3/referenced-network/{countrySubDivision}/{serviceType}"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Assistance General Assets (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/assistance-general-assets.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/assistance-general-assets"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Auto Extended Warranty (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/auto-extended-warranty.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/auto-extended-warranty"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Auto Insurance (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/auto-insurance.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/products-services/v3/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Business (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/business.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/business"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Capitalization Title (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/capitalization-title.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/capitalization-title"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Condominium (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/condominium.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/condominium/{commercializationArea}"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Cyber Risk (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/cyber-risk.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/cyber-risk"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Directors & Officers Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/directors-officers-liability.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/directors-officers-liability"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Domestic Credit (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/domestic-credit.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/domestic-credit"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Engineering (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/engineering.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/engineering"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Environmental Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/environmental-liability.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/environmental-liability"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Equipment Breakdown (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/equipment-breakdown.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/equipment-breakdown"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Errors & Omissions Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/errors-omissions-liability.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/errors-omissions-liability"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Export Credit (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/export-credit.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/export-credit"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Extended Warranty (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/extended-warranty.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/extended-warranty"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Financial Risk (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/financial-risk.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/financial-risk"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — General Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/general-liability.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/general-liability"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Home Insurance (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/home-insurance.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/products-services/v3/home-insurance/commercializationArea/{commercializationArea}"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Housing (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/housing.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/housing"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Life Pension (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/life-pension.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/life-pension"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Lost Profit (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/lost-profit.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/lost-profit"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Pension Plan (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/pension-plan.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/pension-plan"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Person (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/person.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/person"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Private Guarantee (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/private-guarantee.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/private-guarantee"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Public Guarantee (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/public-guarantee.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/public-guarantee"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Rent Guarantee (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/rent-guarantee.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/rent-guarantee"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Rural (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/rural.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/rural"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Stop Loss (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/stop-loss.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/stop-loss"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "1",
    "family": "Open Data — Transport (v3)",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/transport.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/products-services/v3/transport"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Patrimonial",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/quote-patrimonial/v2/lead/request",
      "/open-insurance/quote-patrimonial/v2/lead/request/{consentId}",
      "/open-insurance/quote-patrimonial/v2/home/request",
      "/open-insurance/quote-patrimonial/v2/home/request/{consentId}/quote-status",
      "/open-insurance/quote-patrimonial/v2/home/request/{consentId}",
      "/open-insurance/quote-patrimonial/v2/condominium/request",
      "/open-insurance/quote-patrimonial/v2/condominium/request/{consentId}/quote-status",
      "/open-insurance/quote-patrimonial/v2/condominium/request/{consentId}",
      "/open-insurance/quote-patrimonial/v2/business/request",
      "/open-insurance/quote-patrimonial/v2/business/request/{consentId}/quote-status",
      "/open-insurance/quote-patrimonial/v2/business/request/{consentId}",
      "/open-insurance/quote-patrimonial/v2/diverse-risks/request",
      "/open-insurance/quote-patrimonial/v2/diverse-risks/request/{consentId}/quote-status",
      "/open-insurance/quote-patrimonial/v2/diverse-risks/request/{consentId}"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Responsibility",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/quote-responsibility/v2/lead/request",
      "/open-insurance/quote-responsibility/v2/lead/request/{consentId}"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Financial Risk",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/quote-financial-risk/v2/lead/request",
      "/open-insurance/quote-financial-risk/v2/lead/request/{consentId}"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "3",
    "family": "Quote Acceptance And Branches Abroad",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": [
      "/open-insurance/quote-acceptance-and-branches-abroad/v2/lead/request",
      "/open-insurance/quote-acceptance-and-branches-abroad/v2/lead/request/{consentId}"
    ],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Comuns (Status & Outages) (v2)",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/discovery.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/discovery/v2/status", "/open-insurance/discovery/v2/outages"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  },
  {
    "ecosystem": "opin",
    "phase": "cross-cutting",
    "family": "Admin (Metrics) (v2)",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "surface": "opin-provider-canonical",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/admin_metrics.yaml",
    "ownerPackage": "@finnest/insurance-holder-data",
    "service": "insurance",
    "status": "missing",
    "openapiTags": [],
    "paths": ["/open-insurance/admin/v2/metrics"],
    "evidence": [],
    "notes": "Regulatory target with no Finnest implementation. Backfilled so the catalog reports the full OPIN-stable surface (65 families) instead of only the families we have started."
  }
]
